import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'leaflet/dist/leaflet.css'
// require("https://cdn.jsdelivr.net/npm/katex@0.16.8/dist/contrib/auto-render.min.js")
// require("prismjs/themes/prism.css")

require(`katex/dist/katex.min.css`)
require("prismjs/themes/prism-okaidia.css")

const MEASUREMENT_ID = process.env.GATSBY_GA4_MEASUREMENT_ID || ""

export const onServiceWorkerUpdateReady = () => {
    const answer = window.confirm(
      `This application has been updated. ` +
        `Reload to display the latest version?`
    )
  
    if (answer === true) {
      window.location.reload()
    }
}
  
// Ensure service workers do not interfere with HMR in development
export const onClientEntry = () => {
  if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister())
    })
  }
}

// Send pageview on route changes for gtag (UA)
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return

  const pagePath = location.pathname + (location.search || '')

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: 'page_view', page_path: pagePath })
  }

  if (typeof window.gtag === 'function' && MEASUREMENT_ID) {
    window.gtag('event', 'page_view', { page_path: pagePath, send_to: MEASUREMENT_ID })
  }
}
  
